import { Table } from "@/vendor/Forge/dist";
import { TaoHistory } from "@/types/tao-routing";
import { RowData } from "@/types/my-tasks";
import { styled } from "@stitches/react";
import TaoHistoryField from "../TaoHistoryField";

const Wrapper = styled("div", {
  padding: "0 16px",
  display: "flex",
  width: "100%",
  overflowX: "scroll",
  fontSize: "18px",
  maxFontSize: "18px",
  minFontSize: "18px",
  "& ul li": {
    wordBreak: "break-all",
    whiteSpace: "break-spaces",
  },
  "& table": {
    width: "100%",
    height: "3em",
  },
  "& table th, & table td": {
    border: "1px solid #B6B7B7",
    textAlign: "left",
    maxWidth: "400px",
    verticalAlign: "top",
    fontSize: "18px",
  },
  "& .fe_c_table.fe_c_table--compact tbody td.fe_c_table__cell": {
    padding: "8px 12px",
    fontSize: "18px",
  },
  "& .fe_c_table.fe_c_table--compact thead th.fe_c_table__header": {
    padding: "12px 12px",
  },
  "& .fe_c_toggle-switch": {
    marginTop: "0px",
  },
  ".highlightDestinationBucket tbody tr:first-child td:nth-child(7)": {
    borderLeft: "5px solid Green",
  },
  "& .fe_c_table__cell": {
    fontSize: !"18px",
  },
});

interface Props {
  totalCount: number | undefined;
  totalPages: number | undefined;
  taoHistoryDetails: TaoHistory[];
}

const OverallTaoHistoryTable = ({ taoHistoryDetails }: Props) => {
  const taoHistoryDisplayDetails = taoHistoryDetails.filter(
    (taoHistory) =>
      taoHistory.updatedBy &&
      taoHistory.historyEvents &&
      taoHistory.lastUpdated,
  );
  const columns = [
    {
      key: "taoId",
      displayName: "TAO ID",
    },
    {
      key: "updatedBy",
      displayName: "User",
    },
    {
      key: "historyEvents",
      displayName: "Action Note",
      template: (_field: string, { rowData }: RowData<TaoHistory>) => (
        <TaoHistoryField taoHistoryFieldData={rowData?.historyEvents ?? []} />
      ),
    },
    {
      key: "lastUpdated",
      displayName: "Time Stamp",
    },
  ];

  return (
    <Wrapper>
      <Table
        rowKey="lastUpdated"
        layout="compact"
        columns={columns}
        rows={taoHistoryDisplayDetails}
      />
    </Wrapper>
  );
};

export { OverallTaoHistoryTable };
